import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  addRestaurantSubCategoryFailure,
  addRestaurantSubCategorySuccess,
  deleteRestaurantSubCategoryFailure,
  deleteRestaurantSubCategorySuccess,
  getAllRestaurantCategoryListFailure,
  getAllRestaurantCategoryListSuccess,
  getAllRestaurantSubCategoryListFailure,
  getAllRestaurantSubCategoryListSuccess,
  updateRestaurantSubCategoryFailure,
  updateRestaurantSubCategorySuccess,
  getAllRestaurantVariantListSuccess,
  getAllRestaurantVariantListFailure,
} from "../../Actions";
import { api } from "../../Config/ApiInterface";
import {
  addRestaurantCategoryFailure,
  addRestaurantCategorySuccess,
  addRestaurantVarientFailure,
  addRestaurantVarientSuccess,
  deleteRestaurantCategoryFailure,
  deleteRestaurantCategorySuccess,
  deleteRestaurantVarientFailure,
  deleteRestaurantVarientSuccess,
  updateRestaurantCategoryFailure,
  updateRestaurantCategorySuccess,
  updateRestaurantVariantFailure,
  updateRestaurantVariantSuccess,
} from "../../Actions/Restaurants/RestaurantCateoryAction";

// GET category
function* getRestaurantCategorySaga(action) {
  try {
    const { page, limit, name } = action.payload || {};
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", page);
    if (limit !== undefined) params.append("limit", limit);
    if (name) params.append("name", name); 

    let hotel_id=localStorage.getItem('hotel_id')
    const response = yield call(api.post, `/categories/all?hotel_id=${hotel_id}&${params}`);

    if (response) {
      yield put(getAllRestaurantCategoryListSuccess(response.data));
    } else {
      yield put(
        getAllRestaurantCategoryListFailure(
          response.error || "Failed to fetch Categories."
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllRestaurantCategoryListFailure(error));
    // toast.error("Failed to fetch Categories.");
  }
}

//add category
function* addRestaurantCategorySaga(action) {
  try {
    const response = yield call(
      api.post,
      `/categories/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addRestaurantCategorySuccess(response.data));
      toast.success(response.message);
    } else {
      yield put(
        addRestaurantCategoryFailure(response.error || "Failed to add category")
      );
    }
  } catch (error) {
    yield put(addRestaurantCategoryFailure(error));
    toast.error("Failed to add category");
  }
}

// Edit category
function* updateRestaurantCategorySaga(action) {
  try {
    const hotel_id=localStorage.getItem('hotel_id')

    const payloadData = action.payload;
    const response = yield call(
      api.put,
      `/categories/${payloadData?.id}?hotel_id=${hotel_id}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateRestaurantCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateRestaurantCategoryFailure(
          response.error || "Failed to update category"
        )
      );
    }
  } catch (error) {
    yield put(updateRestaurantCategoryFailure(error));
    toast.error("Failed to update category");
  }
}

//delete room type
function* deleteRestaurantCategorySaga(action) {
  try {
    const hotel_id=localStorage.getItem('hotel_id')

    const payloadData = action.payload;
    const response = yield call(api.delete, `/categories/${payloadData?.id}?hotel_id=${hotel_id}`);
    if (response) {
      yield put(deleteRestaurantCategorySuccess(response.data));
    } else {
      yield put(
        deleteRestaurantCategoryFailure(
          response.error || "Failed to delete room types."
        )
      );
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteRestaurantCategoryFailure(error));
    toast.error("Failed to delete room types.");
  }
}

// subCategory sagas

function* getRestaurantSubCategorySaga(action) {
  try {
    const { page, limit , name} = action.payload?.body || {};
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", page);
    if (limit !== undefined) params.append("limit", limit);
    if (name) params.append("name", name); 

    const hotel_id=localStorage.getItem('hotel_id')
  
    const baseUrl = "/subcategories/by-category";
    const baseUrl1='/subcategories/all';
    const id = action.payload?.id;
    const url = id ? `${baseUrl}/${id}?hotel_id=${hotel_id}&${params}` : `hotel_id=${hotel_id}&${baseUrl1}`;

    const response = yield call(api.post, url);
    if (response) {
      yield put(getAllRestaurantSubCategoryListSuccess(response.data));
    } else {
      yield put(
        getAllRestaurantSubCategoryListFailure(
          response.error || "Failed to fetch Sub Categories."
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllRestaurantSubCategoryListFailure(error));
    // toast.error("Failed to fetch Sub Categories.");
  }
}

function* addRestaurantSubCategorySaga(action) {
  try {
    
    const response = yield call(
      api.post,
      `/subcategories/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addRestaurantSubCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        addRestaurantSubCategoryFailure(
          response.error || "Failed to add Dish item"
        )
      );
    }
  } catch (error) {
    yield put(addRestaurantSubCategoryFailure(error));
    toast.error("Failed to add sub category");
  }
}

function* updateRestaurantSubCategorySaga(action) {
  try {
    const hotel_id=localStorage.getItem('hotel_id')
    
    const payloadData = action.payload;
    const response = yield call(
      api.put,
      `/subcategories/${payloadData?.id}?hotel=${hotel_id}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateRestaurantSubCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateRestaurantSubCategoryFailure(
          response.error || "Failed to update sub category"
        )
      );
    }
  } catch (error) {
    yield put(updateRestaurantSubCategoryFailure(error));
    toast.error("Failed to update sub category");
  }
}

function* deleteRestaurantSubCategorySaga(action) {
  try {
    const hotel_id=localStorage.getItem('hotel_id')

    const payloadData = action.payload;
    const response = yield call(
      api.delete,
      `/subcategories/${payloadData?.id}?hotel_id=${hotel_id}`
    );
    if (response) {
      yield put(deleteRestaurantSubCategorySuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        deleteRestaurantSubCategoryFailure(
          response.error || "Failed to delete sub category"
        )
      );
    }
    toast.success(response.message);
  } catch (error) {
    yield put(deleteRestaurantSubCategoryFailure(error));
    toast.error("Failed to delete sub category");
  }
}

// GET varient
function* getRestaurantVariantSaga(action) {
  try {
    const { page, limit ,name} = action.payload?.body || {};
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", page);
    if (limit !== undefined) params.append("limit", limit);
    if (name) params.append("name", name); 
    const baseUrl = "/variant/by-sub";
    const id = action.payload?.subcategory_id;
    const baseUrl1='/variant/all';

    const url = id ? `${baseUrl}/${id}?${params}` : `${baseUrl1}`;

    const response = yield call(api.post, url);
  
    if (response) {
      yield put(getAllRestaurantVariantListSuccess(response.data));
    } else {
      yield put(
        getAllRestaurantVariantListFailure(
          response.error || "Failed to fetch Varients."
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(getAllRestaurantVariantListFailure(error));
    // toast.error("Failed to fetch Varients.");
  }
}

function* addRestaurantVarientSaga(action) {
  try {
    const response = yield call(
      api.post,
      `/variant/create`,
      action.payload?.body
    );
    if (response) {
      yield put(addRestaurantVarientSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        addRestaurantVarientFailure(
          response.error || "Failed to add variant"
        )
      );
    }
  } catch (error) {
    yield put(addRestaurantVarientFailure(error));
    toast.error("Failed to add variant");
  }
}

// Edit varient
function* updateRestaurantVariantSaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.put,
      `/variant/${payloadData?.id}`,
      action.payload?.body
    );
    if (response) {
      yield put(updateRestaurantVariantSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        updateRestaurantVariantFailure(
          response.error || "Failed to update category"
        )
      );
    }
  } catch (error) {
    yield put(updateRestaurantVariantFailure(error));
    toast.error("Failed to update category");
  }
}

function* deleteRestaurantVarientSaga(action) {
  try {
    const payloadData = action.payload;
    const response = yield call(
      api.delete,
      `/variant/${payloadData?.id}`
    );
    if (response) {
      yield put(deleteRestaurantVarientSuccess(response.data));
      toast.success(response?.data?.message);
    } else {
      yield put(
        deleteRestaurantVarientFailure(
          response.error || "Failed to delete varient"
        )
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(deleteRestaurantVarientFailure(error));
    toast.error("Failed to delete varient");
  }
}

export {
  getRestaurantCategorySaga,
  addRestaurantCategorySaga,
  updateRestaurantCategorySaga,
  deleteRestaurantCategorySaga,
  getRestaurantSubCategorySaga,
  addRestaurantSubCategorySaga,
  updateRestaurantSubCategorySaga,
  deleteRestaurantSubCategorySaga,
  getRestaurantVariantSaga,
  updateRestaurantVariantSaga,
  addRestaurantVarientSaga,
  deleteRestaurantVarientSaga
};
